import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import useIsMobile from "../../../../../../hooks/useIsMobile";
import Utils from "../../../../../../shared/utils";
import AnchorTagWithQueryParams from "../../../../../anchor-tag-with-params";

import DesktopLinksList from "../desktop-links-list";
import MobileLinksList from "../mobile-links-list";

import "./index.scss";

const isAbsoluteUrl = (url) =>
  typeof url === "string" && /^https?:\/\//i.test(url);

export default function LinkContainer({
  link,
  refs,
  onNavClick,
  displayWhiteText,
  isNavOpen,
  isNewSiteActive,
  isMortPersonalAreaActive,
}) {
  const isMobile = useIsMobile();

  useEffect(() => {
    if (!isNavOpen) {
      setIsListOpen(false);
    }
  }, [isNavOpen]);

  const isDesktopListedLink = link.hasTooltip && !isMobile;
  const isMobileListedLink = link.hasTooltip && isMobile;

  const [isListOpen, setIsListOpen] = useState(false);

  const replaceStringPartWithSpan = (string, part) =>
    string.replace(part, `<span class="header-link-highlight">${part}</span>`);

  const labelHtml = replaceStringPartWithSpan(link.text, "חדש!");

  const handleClick = (event) => {
    if (isMobileListedLink) {
      event.preventDefault();
      setIsListOpen(!isListOpen);
    } else if (link.scrollTo) {
      onNavClick(refs[link.ref]);
    }
    Utils.gaEvent(link.category, link.action, link.label);
  };

  const parentClassName = `header-link ${link.bold ? "text-bold" : ""} ${
    displayWhiteText ? "white-text" : ""
  }`;

  const tipProps = {
    "data-tip": true,
    "data-for": link.label,
  };

  const renderParentLink = () => {
    if (isMobileListedLink) {
      return (
        <Link
          {...tipProps}
          className={parentClassName}
          to="#"
          onClick={handleClick}
          dangerouslySetInnerHTML={{ __html: labelHtml }}
        />
      );
    }

    if (isAbsoluteUrl(link.link)) {
      const parentUsesHighlight = link.text.includes("חדש!");
      return (
        <AnchorTagWithQueryParams
          {...tipProps}
          className={parentClassName}
          href={link.link}
          overRideDefaultQueryParams={link.overRideDefaultQueryParams}
          onClick={handleClick}
          text={parentUsesHighlight ? undefined : link.text}
        >
          {parentUsesHighlight ? (
            <span dangerouslySetInnerHTML={{ __html: labelHtml }} />
          ) : null}
        </AnchorTagWithQueryParams>
      );
    }

    return (
      <Link
        {...tipProps}
        className={parentClassName}
        to={link.link ?? "#"}
        onClick={handleClick}
        dangerouslySetInnerHTML={{ __html: labelHtml }}
      />
    );
  };

  const syncTooltipAccentWidth = (event) => {
    const anchor = event.currentTarget.querySelector("a");
    if (anchor) {
      document.documentElement.style.setProperty(
        "--header-tooltip-accent-width",
        `${anchor.offsetWidth}px`
      );
    }
  };

  return (
    <div
      className="link-and-tooltip-container"
      onMouseEnter={isDesktopListedLink ? syncTooltipAccentWidth : undefined}
    >
      {renderParentLink()}
      {isMobileListedLink && (
        <MobileLinksList
          isNewSiteActive={isNewSiteActive}
          isMortPersonalAreaActive={isMortPersonalAreaActive}
          isListOpen={isListOpen}
          setIsListOpen={setIsListOpen}
          link={link}
        />
      )}
      {isDesktopListedLink && (
        <DesktopLinksList
          link={link}
          isNewSiteActive={isNewSiteActive}
          isMortPersonalAreaActive={isMortPersonalAreaActive}
        />
      )}
    </div>
  );
}
